<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="page-breadcrumb">
         <ul class="page-breadcrumb__trail">
            <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Manage</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Business</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Business Entities</a></li>
            <li *ngIf="loginPersonType == 'EMPLOYEE'"><a>Provider Farm Businesses</a></li>
            <li *ngIf="(loginPersonType == 'Business Admin' || loginPersonType == 'Provider Manager') && paramBusiness == 'Customers'"><a>Your Customers</a></li>
            <li *ngIf="(loginPersonType == 'Business Admin' || loginPersonType == 'Provider Manager') && paramBusiness == 'Business'"><a>Your Business</a></li>
          </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home/Business-Entity/{{paramBusiness}}" *ngIf="loginPersonType != 'Business Admin' && loginPersonType != 'Provider Manager'"><img
            src="../../../../../../../assets/images/New_Icons/back-transprent-icon.svg" title="Back"></a>
          <a routerLink="/home"><img src="../../../../../../../assets/images/New_Icons/home-transprent-icon.svg"
                                     title="Home"></a>
        </div>
      </div>
      <div class="block" [hidden]="!pgLoad">
        <div class="row business_info_container" *ngIf="appPermission?.[0]?.businessDetails">
          <div class="business_info_details">
            <div class="business_name_div">
              <span>{{businessEntity && businessEntity.businessName}}</span><br>
            </div>
            <div class="business_info">
              <div class="business_address_div">
                <span>
                  {{((businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].street}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].city}}
                </span>
              </div>
              <div class="business_email_div">
                <img src="../../../../../../../assets/images/New_Icons/email-icon.svg">
                <span>{{businessEntity && businessEntity.email == '' || businessEntity && businessEntity.email == null ? 'NA' : businessEntity && businessEntity.email}}</span>
              </div>
              <div class="business_mobile_number_div">
                <img src="../../../../../../../assets/images/New_Icons/mobile-icon.svg">
                <span>{{businessEntity && businessEntity.dialingCode}} {{businessEntity && businessEntity.mobileNumber }}</span>
              </div>
              <div class="business_type_div">
                <img src="../../../../../../../assets/images/New_Icons/company-name-icon.svg">
                <span>{{businessEntity && businessEntity.businessType[0] && businessEntity.businessType[0].name}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row business_info_container" *ngIf="paramBusiness == 'Business'">
          <div class="business_info_details">
            <div class="business_name_div">
              <span>{{businessEntity && businessEntity.businessName}}</span><br>
            </div>
            <div class="business_info">
              <div class="business_address_div">
                <span>
                  {{((businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].street}}
                  ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == '' || (businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == null) ? 'NA' : businessEntity && businessEntity.address[0] && businessEntity.address[0].city}}
                </span>
              </div>
              <div class="business_email_div">
                <img src="../../../../../../../assets/images/New_Icons/email-icon.svg">
                <span>{{businessEntity && businessEntity.email == '' || businessEntity && businessEntity.email == null ? 'NA' : businessEntity && businessEntity.email}}</span>
              </div>
              <div class="business_mobile_number_div">
                <img src="../../../../../../../assets/images/New_Icons/mobile-icon.svg">
                <span>{{businessEntity && businessEntity.dialingCode}} {{businessEntity && businessEntity.mobileNumber }}</span>
              </div>
              <div class="business_type_div">
                <img src="../../../../../../../assets/images/New_Icons/company-name-icon.svg">
                <span>{{businessEntity && businessEntity.businessType[0] && businessEntity.businessType[0].name}}</span>
              </div>
              <div class="business_edit" title="Edit Business"
                   (click)="getBusinessEntityById(businessEntity && businessEntity.id)">
                <img src="../../../../../../../assets/images/New_Icons/edit.svg">
              </div>
              <div class="business_type_div">
                <img src="../../../../../../../assets/images/New_Icons/delete-icon.svg" (click)="navigateToAccountClosurePopupOpenScreen(businessEntity)" style="cursor: pointer;">
                <span style="color: red;">Account Clsoure</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="!pgLoad" *ngIf="paramBusiness == 'Customers'">
          <div class="screen_heading_div">
            <span>Your Customers</span>
          </div>
        </div>
        <div class="row" *ngIf="(paramBusiness == 'Customers' && loginPersonType == 'Business Admin')">
          <div class="search_cum_icons_button_container">
            <div class="gap"></div>
            <div class="add-button-container" (click)="openForm()">
              <button class="button">
                <span class="icon"><img src="../../../../../../../assets/images/New_Icons/plus-icon.svg"></span>
                <span class="text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row" [hidden]="!pgLoad">
          <div *ngIf=" businessEntities && businessEntities.length == 0"
               style="margin-top: 20px; text-align: center">
            <h1>Farms are not available</h1>
          </div>
          <div class="cards_container" *ngIf="(loginPersonType== 'Business Admin' && paramBusiness == 'Customers') || loginPersonType == 'EMPLOYEE' || loginPersonType == 'Provider Manager'">
            <div class="card_wrapper" *ngFor="let eachaactivedocdata of businessEntities">
              <div class="each_card_div">
                <div class="card_content">
                  <div class="card_header">
                    <div class="img_cum_business_name_div">
                      <img src="../../../../../../../assets/images/New_Icons/card-heading.svg">
                      <!-- <span routerLink="'/home/BusinessFP-Farm-Farmsite', businessEntity?.id, eachaactivedocdata?.id, paramBusiness">
                        {{ eachaactivedocdata?.businessName ? eachaactivedocdata.businessName : 'NA' }}
                      </span> -->
                      <span
                        routerLink="/home/BusinessFP-Farm-Farmsite/{{businessEntity && businessEntity.id}}/{{eachaactivedocdata && eachaactivedocdata.id}}/{{paramBusiness}}">{{(eachaactivedocdata && eachaactivedocdata.businessName) == "" ? 'NA' : eachaactivedocdata && eachaactivedocdata.businessName}}</span>
                    </div>
                  </div>
                  <div class="card_body">
                    <div>
                      <img src="../../../../../../../assets/images/New_Icons/phone-card-icon.svg">
                      <span>{{eachaactivedocdata && eachaactivedocdata.dialingCode}} {{(eachaactivedocdata && eachaactivedocdata.mobileNumber == '' || eachaactivedocdata && eachaactivedocdata.mobileNumber == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.mobileNumber}}</span>
                    </div>
                    <div>
                      <img src="../../../../../../../assets/images/New_Icons/email-card-icon.svg">
                      <span>{{(eachaactivedocdata && eachaactivedocdata.email == '' || eachaactivedocdata && eachaactivedocdata.email == null) ? 'NA' : eachaactivedocdata && eachaactivedocdata.email}}</span>
                    </div>
                    <div>
                      <img src="../../../../../../../assets/images/New_Icons/address-card-icon.svg">
                      <span
                        class="description">{{(eachaactivedocdata && eachaactivedocdata.address.length > 0 ? (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? ((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) + ', ' + (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) : (((eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && !(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) : (!(eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].pincode) && (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district)) ? (eachaactivedocdata && eachaactivedocdata.address.length > 0 && eachaactivedocdata.address[0].district) : '')) : 'NA') || 'NA'}}</span>
                    </div>
                  </div>
                </div>
                <div class="card_footer">
                  <div class="separate_field">
                    <span class="field_text"></span>
                    <span class="field_value_text"></span>
                  </div>
                  <div class="activities_icons">
                    <img src="../../../../../../../assets/images/New_Icons/view-profile-icon.svg"
                         title="View Profile" style="padding: 8px" *ngIf="paramBusiness == 'Customers'"
                         (click)="getBusinessProfileById(eachaactivedocdata.id)">
                    <img src="../../../../../../../assets/images/New_Icons/edit.svg" title="Edit Business"
                         (click)="getBusinessEntityById(eachaactivedocdata.id)" *ngIf="loginPersonType != 'Provider Manager'">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Customer Profile-->
      <div class="modal fade" id="farmModal" role="dialog">
        <div class="modal-dialog modal-lg addBusinessEntityModal">
          <div class="modal-content eachContent">
            <div class="modal-header">
              <button type="button" title="Close Popup" class="close"
                      data-dismiss="modal" (click)="modalClose()">&times;
              </button>
              <h4 class="modal-title">Customer Profile</h4>
            </div>
            <div [hidden]="responseLoader">
              <div class="adjust">
                <div class="loader2"></div>
              </div>
            </div>
            <div class="modal-body eachCustomer">
              <div class="row customerData">
                <div class="col-xs-12">
                  <div class="col-xs-4 customerName">
                    <div class="col-xs-4">
                      <img src="../../../../../../../assets/image/business/customerIcon.svg"/></div>
                    <div class="col-xs-8">
                      <p>{{businessEntity && businessEntity.businessName}}</p>
                      <p>{{businessEntity && businessEntity.address.length > 0 && businessEntity.address[0] && businessEntity.address[0].city}}</p>
                      <p>{{businessEntity && businessEntity.dialingCode}} {{businessEntity && businessEntity.mobileNumber}}</p>
                    </div>
                  </div>
                  <div class="sitelength">
                    <div class="col-xs-3" *ngIf="farmsiteIds && farmsiteIds.length == 1">
                      <p>Site
                        Name&nbsp;&nbsp;: {{farmSites && farmSites.length > 0 && farmSites[0].farmNameAtLocation || 'NA'}}</p>
                      <p *ngIf="selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">Soil
                        Type&nbsp;&nbsp;&nbsp;&nbsp;: {{farmSites && farmSites.length > 0 && farmSites[0].soilType && farmSites[0].soilType.name || 'NA'}}</p>
                    </div>
                    <div class="col-xs-3" *ngIf="farmsiteIds && farmsiteIds.length > 1 && selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                      <p>Total Sites&nbsp;&nbsp;: {{farmsiteIds && farmsiteIds.length}}</p>
                    </div>
                    <div class="col-xs-3" *ngIf="selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                      <p>Total Ponds&nbsp;: {{customerPonds && customerPonds.length}}</p>
                      <p *ngIf="farmsiteIds && farmsiteIds.length == 1">Water
                        Type&nbsp;&nbsp;: {{farmSites && farmSites.length > 0 && farmSites[0].soilType && farmSites[0].waterType.name || 'NA'}}</p>
                    </div>
                    <div class="col-xs-2" *ngIf="selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                      <p>Total Area&nbsp;&nbsp;&nbsp;: {{areaCount}} ha</p>
                    </div>
                  </div>
                </div>
                <div class="techName">
                  <p>Assigned To</p>
                  <p>{{loginUserBusinessName}}</p>
                </div>
              </div>
              <div class="row customerDetails" *ngIf="selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                <div class="row">
                  <div class="col-xs-12 col-md-6 col-sm-6 col-lg-9">
                    <h4>Site level metrics</h4>
                  </div>
                  <div class="col-xs-12 col-md-6 col-sm-6 col-lg-3 siteselection">
                    <select name="farmsite" [(ngModel)]="farm_site_id" class="form-control select"
                            (change)="getSiteLevelMetric()" required>
                      <option value="undefined" selected>All</option>
                      <option value="{{site.id}}" *ngFor="let site of farmSites">{{site.farmNameAtLocation}}</option>
                    </select>
                    <span class="caret history-caret"></span>
                  </div>
                </div>
                <div class="row-flex" style="margin-top: 10px;">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Total Consumption</p>
                      <h3>{{(feedLog && feedLog.totalConsumption == null) ? 'NA' : feedLog && feedLog.totalConsumption + ' ' + 'Kgs'}}</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Total Biomass</p>
                      <h3>{{(feedLog && feedLog.totalBiomass == null) ? 'NA' : (feedLog && feedLog.totalBiomass + ' ' + 'Kgs')}}</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Present Biomass</p>
                      <h3>{{(feedLog && feedLog.presentBiomass == null) ? 'NA' : (feedLog && feedLog.presentBiomass + ' ' + 'Kgs')}}</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Harvested Biomass</p>
                      <h3>{{(feedLog && feedLog.harvestedBiomass == null) ? 'NA' : (feedLog && feedLog.harvestedBiomass + ' ' + 'Kgs')}}</h3>
                    </div>
                  </div>
                </div>
                <div class="row-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Survival Rate (%)</p>
                      <h3>{{(feedLog && feedLog.survivalRate == null) ? 'NA' : feedLog && feedLog.survivalRate}} %</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>FCR</p>
                      <h3>{{(feedLog && feedLog.FCR == null) ? 'NA' : feedLog && feedLog.FCR}}</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pondlevelDetails" *ngIf="selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                <div class="row">
                  <div class="col-xs-12 col-md-6 col-sm-6 col-lg-9">
                    <h4>Pond level metrics</h4>
                  </div>
                  <div class="col-xs-12 col-md-6 col-sm-6 col-lg-3 siteselection">
                    <select name="pond" [(ngModel)]="pond_id" class="form-control select"
                            (change)="getPondLevelDataByPondId()"
                            required>
                      <option value="undefined" selected>All</option>
                      <option value="{{pond.pond_id}}"
                              *ngFor="let pond of activepondsDetails_dropdown">{{pond.pond_name}}</option>
                    </select>
                    <span class="caret"></span>
                  </div>
                </div>
                <div class="row-flex" style="margin-top: 10px;">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Total Consumption</p>
                      <h3>{{(pondLevelFeedLog && pondLevelFeedLog.totalConsumption == null) ? 'NA' : pondLevelFeedLog && pondLevelFeedLog.totalConsumption + ' ' + 'Kgs'}}</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Total Biomass</p>
                      <h3>{{(pondLevelFeedLog && pondLevelFeedLog.totalBiomass == null) ? 'NA' : (pondLevelFeedLog && pondLevelFeedLog.totalBiomass + ' ' + 'Kgs')}}</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Present Biomass</p>
                      <h3>{{pondLevelFeedLog && pondLevelFeedLog.presentBiomass == null ? 'NA' : (pondLevelFeedLog && pondLevelFeedLog.presentBiomass + ' ' + 'Kgs')}} </h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Harvested Biomass</p>
                      <h3
                        *ngIf="!pond_id">{{(pondLevelFeedLog && pondLevelFeedLog.harvestedBiomass == null) ? 'NA' : (pondLevelFeedLog && pondLevelFeedLog.harvestedBiomass + ' ' + 'Kgs')}}</h3>
                      <h3
                        *ngIf="pond_id">{{pondLevelFeedLog && pondLevelFeedLog.totalHarvestCount == null ? 'NA' : (pondLevelFeedLog && pondLevelFeedLog.totalHarvestCount + ' ' + 'Kgs')}}</h3>
                    </div>
                  </div>
                </div>
                <div class="row-flex">
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>Survival Rate (%)</p>
                      <h3>{{pondLevelFeedLog && pondLevelFeedLog.survivalRate}} %</h3>
                    </div>
                  </div>
                  <div class="col-md-3 col-sm-6 col-xs-12">
                    <div class="content colour-1">
                      <p>FCR</p>
                      <h3>{{(pondLevelFeedLog && pondLevelFeedLog.FCR == null) ? 'NA' : pondLevelFeedLog && pondLevelFeedLog.FCR}}</h3>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="pond_id && selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                <h4 style="color: #000; margin-bottom: 18px;">Pond Name:
                  {{pondCulture && pondCulture.feedlogs && pondCulture.feedlogs[0] && pondCulture.feedlogs[0].pondName}}</h4>
                <div class="col-xs-12">
                  <div class="x_chart_panel">
                    <div *ngIf="myChartNodata">No Feedlog vs DOC data</div>
                    <div [hidden]="myChartNodata" class="x_content">
                      <canvas id="myChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
              <!--Sampling vs doc charts-->
              <div class="row" *ngIf="pond_id && selectedBusinessEntity?.businessType?.[0]?.name == 'Farm'">
                <div class="col-xs-12">
                  <div class="x_chart_panel">
                    <div *ngIf="mySamplingvsDocData">No ABW vs DOC data</div>
                    <div *ngIf="!mySamplingvsDocData" class="x_content">
                      <canvas id="samplingChart"></canvas>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Business add/update-->

      <div class="dynamic-form-wrapper"
          [ngClass]="{
            'floating-panel': formFieldCount <= 7,
            'slide-in-overlay': formFieldCount > 7
          }"
          *ngIf="showForm">


        <div class="popup-wrapper">
          
          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">
            &times;
          </button>

          <!-- Actual Popup -->
          <div [ngClass]="{
              'form-container-panel': formFieldCount > 7,
              'popup-inner': formFieldCount <= 7
            }">

            <form [formGroup]="registerForm">
              <div class="form-header">
                <div class="form-title">Business</div>
                <!-- ───────── Multi-state action buttons ───────── -->
                <!-- CASE 1: showsiteform = true  →  “Submit” + “Delete” -->
                <div *ngIf="showsiteform; else singleAction" style="display: flex;">
                  <!-- Submit -->
                  <button
                    type="button"
                    class="add-update-submit-button"
                    (click)="addFarmSite()"
                    [disabled]="locationDoubleClick"
                  >
                    <span class="icon">
                      <img src="../../../../assets/images/New_Icons/tick-icon.svg" />
                    </span>
                    <span class="text">Submit</span>
                  </button>

                  <!-- Delete -->
                  <button
                    type="button"
                    class="add-update-submit-button delete-btn ml-2"
                    (click)="deleteBusinessDetails()"
                  >
                    <span class="icon">
                      <img src="../../../../assets/images/New_Icons/delete-icon.svg" />
                    </span>
                    <span class="text">Delete</span>
                  </button>
                </div>

                <!-- CASE 2: submitButton / updateButton  →  single action -->
                <ng-template #singleAction>
                  <button
                    type="button"
                    class="add-update-submit-button"
                    (click)="getMethodsDynamically()"
                    [disabled]="businessCreationDoubleClick"
                  >
                    <span class="icon">
                      <img src="../../../../assets/images/New_Icons/tick-icon.svg" />
                    </span>
                    <span class="text">
                      {{ submitButton ? 'Next' : updateButton ? 'Update' : '' }}
                    </span>
                  </button>
                </ng-template>

              </div>
              
              <div class="form-container" style="padding-bottom: 0;">
                <span class="container-title">Business Info</span>

                <!-- ───────── Info Banner (kept as‑is) ───────── -->
                <div
                  class="businessCode_info_css"
                  *ngIf="registerBusiness.businessCode"
                >
                  <img
                    src="../../../../assets/images/New_Icons/info-icon.svg"
                    height="20"
                    width="20"
                  />
                  <span>
                    Unique ID will be used to uniquely identify your business and products
                    (Seed) for your potential consumers
                  </span>
                </div>

                <!-- === Section: Business Information === -->
                <div class="form-section">
                  <div class="grid-three-cols">

                    <!-- ───────── BUSINESS NAME ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Business Name</mat-label>
                      <input
                        matInput
                        id="businessName"
                        autocomplete="off"
                        formControlName="businessName"
                        [(ngModel)]="registerBusiness.businessName"
                        (input)="onBusinessChange()"
                        (keyup)="getBusinessCode()"
                      />

                      <mat-hint>
                        <i>5-30 alaphabetic characters</i>
                      </mat-hint>

                      <!-- Validation -->
                      <mat-error *ngIf="(submitted || f.businessName.touched || f.businessName.dirty) && f.businessName.errors">
                        <ng-container *ngIf="f.businessName.hasError('required')">Business name is <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('minlength')">Must be <i>at least 5 characters</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('maxlength')">Cannot exceed <i>30 characters</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('pattern')">No numbers or special characters allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── BUSINESS CODE (readonly) ───────── -->
                    <mat-form-field
                      *ngIf="registerBusiness.businessCode"
                      appearance="outline"
                      class="w-100 disbledCls"
                    >
                      <mat-label>Your unique ID</mat-label>
                      <input
                        matInput
                        id="businessCode" 
                        readonly
                        formControlName="businessCode"
                        [(ngModel)]="registerBusiness.businessCode"
                      />
                    </mat-form-field>

                    <!-- ───────── BUSINESS CATEGORY ───────── -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Business Category</mat-label>
                      <mat-select
                        formControlName="category"
                        [(ngModel)]="businessCategory.businessCategoryID"
                        (selectionChange)="getBusinessTypesByCategory()"
                      >
                        <mat-option value="undefined" disabled>Select Business Category</mat-option>
                        <mat-option *ngFor="let cat of businessCategories" [value]="cat.id">
                          {{ cat.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f.category.invalid">
                        <i>Select business category</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.category.valid">
                        <i>Business category selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.category.touched || f.category.dirty) && f.category.hasError('required')"
                      >
                        Business category is <i>required</i>.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── BUSINESS TYPE ───────── -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Business Type</mat-label>
                      <mat-select
                        id="businessType"
                        formControlName="businessType"
                        [(ngModel)]="businessType.businessTypeID"
                      >
                        <mat-option value="undefined" disabled>Select Business Type</mat-option>
                        <mat-option *ngFor="let type of dupbusinessTypes" [value]="type.id">
                          {{ type.name }}
                        </mat-option>
                      </mat-select>

                       <mat-hint *ngIf="f.businessType.invalid">
                        <i>Select business type</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.businessType.valid">
                        <i>Business type selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.businessType.touched || f.businessType.dirty) && f.businessType.hasError('required')"
                      >
                        Business type is <i>required</i>.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── COUNTRY (autocomplete) ───────── -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Country Selection</mat-label>
                      <input
                        matInput
                        id="country"
                        autocomplete="off"
                        formControlName="countryName"
                        [matAutocomplete]="autoCountry"
                        (focus)="filteredOptions=countries"
                        (keyup)="filterCountries()"
                      />

                      <mat-autocomplete #autoCountry="matAutocomplete" (optionSelected)="countrySelected($event.option.value)">
                        <mat-option *ngFor="let c of filteredOptions" [value]="c">
                          {{ c.name }}
                        </mat-option>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f.countryName.invalid">
                        <i>Select country</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.countryName.valid">
                        <i>Country selected</i>
                      </mat-hint>

                      <mat-error *ngIf="(submitted || f.countryName.touched || f.countryName.dirty) && f.countryName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── DIAL CODE (readonly) ───────── -->
                    <mat-form-field appearance="outline" class="w-100 dialcode-farm-element" [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Dial Code</mat-label>
                      <input
                        matInput
                        id="dialCode"
                        readonly
                        formControlName="dialCode"
                        [(ngModel)]="registerBusiness.dialingCode"
                      />
                    </mat-form-field>

                  </div>
                </div>

                <!-- === Section: Contact Details === -->
                <div class="form-section">
                  <h3 class="section-title">Contact Details</h3>
                  <div class="grid-three-cols">

                    <!-- Email -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Email ID</mat-label>
                      <input
                        matInput
                        id="email"
                        autocomplete="off"
                        formControlName="email"
                        [(ngModel)]="registerBusiness.email"
                      />
                      <mat-error *ngIf="(submitted || f.email.touched || f.email.dirty) && f.email.errors">
                        <ng-container *ngIf="f.email.hasError('pattern')">Must be a <i>valid email</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- Mobile -->
                    <mat-form-field appearance="outline" class="w-100" [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Mobile Number</mat-label>
                      <input
                        matInput
                        id="mobileNumber"
                        autocomplete="off"
                        formControlName="mobilenumber"
                        [(ngModel)]="registerBusiness.mobileNumber"
                      />
                      <mat-error *ngIf="(submitted || f.mobilenumber.touched || f.mobilenumber.dirty) && f.mobilenumber.errors">
                        <ng-container *ngIf="f.mobilenumber.hasError('required')">Mobile number is <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.mobilenumber.hasError('pattern')">Enter a <i>valid mobile number</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

              </div>
            </form>

            <form [formGroup]="addFarmsiteForm" *ngIf="showsiteform">
              <div class="form-container" style="padding-top: 0;">

                <span class="container-title">Location Info</span>

                <!-- === Section: Farm Location Details === -->
                <div class="form-section">
                  <div class="grid-three-cols">
                    <!-- ───────── LOCATION NAME ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Location Name</mat-label>
                      <input
                        matInput
                        id="locationname"
                        autocomplete="off"
                        placeholder=""
                        formControlName="farmNameAtLocation"
                        [(ngModel)]="farmSite.farmNameAtLocation"
                      />

                      <mat-hint>
                        <i>3-30 alphabetic characters</i>
                      </mat-hint>

                      <mat-error *ngIf="(farmSitesubmitted || f1.farmNameAtLocation.touched || f1.farmNameAtLocation.dirty)">
                        <ng-container *ngIf="f1.farmNameAtLocation.hasError('required')">Required.</ng-container>
                        <ng-container *ngIf="f1.farmNameAtLocation.hasError('minlength')">Minimum 3 characters required.</ng-container>
                        <ng-container *ngIf="f1.farmNameAtLocation.hasError('maxlength')">Maximum 30 characters allowed.</ng-container>
                        <ng-container *ngIf="f1.farmNameAtLocation.hasError('pattern')">Numbers not allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>
                    <!-- ───────── YEAR STARTED ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Year Started</mat-label>
                      <mat-select
                        id="yearstarted"
                        formControlName="yearStarted"
                        [(ngModel)]="farmSite.yearStarted"
                      >
                        <mat-option value="undefined" disabled>Select Year</mat-option>
                        <mat-option *ngFor="let year of yearStartedArr" [value]="year">
                          {{ year }}
                        </mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f1.yearStarted.invalid">
                        <i>Select year</i>
                      </mat-hint>
                      <mat-hint *ngIf="f1.yearStarted.valid">
                        <i>Year selected</i>
                      </mat-hint>

                      <mat-error *ngIf="(farmSitesubmitted || f1.yearStarted.touched || f1.yearStarted.dirty) && f1.yearStarted.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Address Details === -->
                <div class="form-section">
                  <h3 class="section-title">Address Details</h3>
                  <div class="grid-three-cols">
                    <!-- ───────── STATE ───────── -->
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                    >
                      <mat-label>State Selection</mat-label>
                      <input
                        matInput
                        id="state"
                        autocomplete="off"
                        formControlName="stateName"
                        [matAutocomplete]="autoState"
                        (focus)="filteredStates=states"
                        (keyup)="filterStates()"
                      />

                      <mat-autocomplete
                        #autoState="matAutocomplete"
                        (optionSelected)="stateSelection($event.option.value)"
                      >
                        <mat-option *ngFor="let s of filteredStates" [value]="s">
                          {{ s.name }}
                        </mat-option>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f1.stateName.invalid">
                        <i>Select state</i>
                      </mat-hint>
                      <mat-hint *ngIf="f1.stateName.valid">
                        <i>State selected</i>
                      </mat-hint>

                      <mat-error *ngIf="(farmSitesubmitted || f1.stateName.touched || f1.stateName.dirty) && f1.stateName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>
                    <!-- ───────── VILLAGE ───────── -->
                      <mat-form-field appearance="outline" class="w-100" [ngClass]="{ disbledCls: stateVillageDisabled }">
                  <mat-label>Village Selection</mat-label>

                  <input
                    matInput
                    id="village"
                    autocomplete="off"
                    formControlName="villageName"
                    [matAutocomplete]="autoVillage"
                    [disabled]="stateVillageDisabled || isLoadingVillages"
                    (keyup)="filterVillages($event)"
                    (focus)="onVillageFocus()"
                    (blur)="onVillageBlur()"
                    #autoTrigger="matAutocompleteTrigger"
                  />

                  <!-- Loader while fetching API -->
                  <mat-spinner *ngIf="isLoadingVillages" diameter="20" class="absolute right-2 top-2"></mat-spinner>

                  <mat-autocomplete #autoVillage="matAutocomplete" panelClass="village-panel">
                    <!-- Error message if API fails -->
                    <mat-option *ngIf="villagesLoadError" disabled>
                      Villages fetching failed. Reselect state to retry.
                    </mat-option>

                    <!-- No data found message -->
                    <mat-option *ngIf="noDataFound" disabled>
                      No data found
                    </mat-option>

                    <!-- Virtual Scroll Container -->
                    <cdk-virtual-scroll-viewport itemSize="48" style="height: 250px;" 
                      [style.height.px]="visibleVillages.length < CHUNK_SIZE ? visibleVillages.length * 48 : 250"
                      (scrolledIndexChange)="onVillageScroll()"
                      [minBufferPx]="500"
                      [maxBufferPx]="1000">
                      <div *cdkVirtualFor="let v of visibleVillages; let i = index">
                        <mat-option [value]="v.city_town_village_name" (click)="villageSelection(v)">
                          {{ v.city_town_village_name }}
                        </mat-option>
                      </div>

                      <!-- Loader inside scroll -->
                      <div class="loader-section" *ngIf="isLoadingMore">
                        <mat-spinner diameter="20"></mat-spinner>
                        <span>Loading more...</span>
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </mat-autocomplete>

                  <mat-hint *ngIf="f1.villageName.invalid"><i>Select village</i></mat-hint>
                  <mat-hint *ngIf="f1.villageName.valid"><i>Village selected</i></mat-hint>

                  <mat-error *ngIf="(farmSitesubmitted || f1.villageName.touched || f1.villageName.dirty) && f1.villageName.hasError('required')">
                    Required.
                  </mat-error>
              </mat-form-field>
                  </div>
                </div>

                <!-- === Section: Water & Soil Information === -->
                <div class="form-section">
                  <h3 class="section-title">Water & Soil Information</h3>
                  <div class="grid-three-cols">
                    <!-- ――――――――――――――  Water Type  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Water Type</mat-label>

                      <mat-select
                        id="qptype"
                        formControlName="waterTypeId"
                        [(ngModel)]="waterType.waterTypeId"
                        placeholder="Select Water Type"
                      >
                        <mat-option disabled selected value="undefined">Select Water Type</mat-option>
                        <mat-option *ngFor="let type of waterTypes" [value]="type.id">
                          {{ type.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint><i>Select the applicable water source</i></mat-hint>

                      <mat-error *ngIf="(f1.waterTypeId.touched || farmSitesubmitted) && f1.waterTypeId.errors">
                        <i>
                          {{
                            f1.waterTypeId.hasError('required')
                              ? 'Water type is required.'
                              : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                    <!-- ――――――――――――――  Soil Type  ―――――――――――――― -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Soil Type</mat-label>

                      <mat-select
                        id="category"
                        formControlName="soilTypeId"
                        [(ngModel)]="soilType.soilTypeId"
                        placeholder="Select Soil Type"
                      >
                        <mat-option disabled selected value="undefined">Select Soil Type</mat-option>
                        <mat-option *ngFor="let category of soilTypes" [value]="category.id">
                          {{ category.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint><i>Choose the soil category</i></mat-hint>

                      <mat-error *ngIf="(f1.soilTypeId.touched || farmSitesubmitted) && f1.soilTypeId.errors">
                        <i>
                          {{
                            f1.soilTypeId.hasError('required')
                              ? 'Soil type is required.'
                              : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                 <!-- === Section: Provider Technician === -->
                <div class="form-section">
                  <h3 class="section-title">Provider Technician</h3>
                  <div class="grid-three-cols">
                    <mat-form-field
                      appearance="outline"
                      class="w-100"
                    >
                      <mat-label>Provider Technician</mat-label>

                      <mat-select
                        id="batech"
                        [(ngModel)]="feedProviderPersonID"
                        formControlName="providerTech"
                        placeholder="Select Provider Technician"
                      >
                        <mat-option value="undefined" disabled selected>Select Provider Technician</mat-option>
                        <mat-option *ngFor="let person of businessAdminPersons" [value]="person.id">
                          {{ person.firstName }} ({{ person.personType[0].name }})
                        </mat-option>
                      </mat-select>

                      <mat-hint><i>Select the technician for this provider</i></mat-hint>

                      <mat-error
                        *ngIf="(f1.providerTech.touched || farmSitesubmitted) && f1.providerTech.errors"
                      >
                        <i>
                          {{
                            f1.providerTech.hasError('required')
                              ? 'Provider technician is required.'
                              : ''
                          }}
                        </i>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
